<template>
<div>
    <div class="div-spans-title mt-4">
        <span @click="showPanelFn" class="span-laboral">
          {{$t('backoffice.user-management.form-user.user-access-config.week-days-component-title')}}
          <svg :class="showPanel ? 'rotated' : 'rotatedback'" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" /></svg>
        </span>
        <div class="div-bottom-line">
        </div>
    </div>
    <div v-if="showPanel" class="mt-6">
        <v-expansion-panels>
            <v-expansion-panel v-for="(day, i) in weekDays" :key="i">
                <v-expansion-panel-header @click="handleClickPanelHeader(i)">
                    {{tanslateDayName(day.name)}}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-col cols="12" class="d-flex flex-row p-0" v-if="day.timeRanges.length > 0">
                        <v-col sm="2"><span>{{$t('backoffice.user-management.form-user.user-access-config.start-hour')}}</span></v-col>
                        <v-col sm="2"><span>{{$t('backoffice.user-management.form-user.user-access-config.end-hour')}}</span></v-col>
                    </v-col>
                    <v-row v-for="(time, index) in day.timeRanges" :key="index">
                        <v-col cols="12" v-if="time.isEditable" class="d-flex flex-row">
                            <v-col sm="3">
                                <v-form v-model="time.inputValidations.startHour">
                                    <v-dialog
                                        ref="startHour"
                                        v-model="modal1"
                                        :return-value.sync="time.startHour"
                                        persistent
                                        width="290px"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            ref="timeStartHour"
                                            v-model="time.startHour"
                                            :label="$t('backoffice.user-management.form-user.user-access-config.week-days-component-start-hour')"
                                            prepend-icon="mdi-clock-time-four-outline"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            :rules="[startHourRulesForm(time.startHour, time.endHour, day, index)]"
                                        ></v-text-field>
                                        </template>
                                        <v-time-picker
                                            v-if="modal1"
                                            v-model="time.startHour"
                                            full-width
                                            format="24hr"
                                        >
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            text
                                            color="primary"
                                            @click="modal1 = false"
                                        >
                                            {{$t('backoffice.actions.cancel')}}
                                        </v-btn>
                                        <v-btn
                                            text
                                            color="primary"
                                            @click="saveStartHour(time.startHour)"
                                        >
                                            {{$t('backoffice.actions.record')}}
                                        </v-btn>
                                        </v-time-picker>
                                    </v-dialog>
                                </v-form>
                            </v-col>
                            <v-col sm="3">
                                <v-form v-model="time.inputValidations.endHour">
                                    <v-dialog
                                        ref="endHour"
                                        v-model="modal2"
                                        :return-value.sync="time.endHour"
                                        persistent
                                        width="290px"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            ref="timeEndHour"
                                            v-model="time.endHour"
                                            :label="$t('backoffice.user-management.form-user.user-access-config.week-days-component-end-hour')"
                                            prepend-icon="mdi-clock-time-four-outline"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            :rules="[endHourRulesForm(time.startHour, time.endHour, day, index)]"
                                        ></v-text-field>
                                        </template>
                                        <v-time-picker
                                            v-if="modal2"
                                            v-model="time.endHour"
                                            full-width
                                            format="24hr"
                                        >
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            text
                                            color="primary"
                                            @click="modal2 = false"
                                        >
                                            {{$t('backoffice.actions.cancel')}}
                                        </v-btn>
                                        <v-btn
                                            text
                                            color="primary"
                                            @click="saveEndHour(time.endHour); modal2 = false"
                                        >
                                            {{$t('backoffice.actions.record')}}
                                        </v-btn>
                                        </v-time-picker>
                                    </v-dialog>
                                </v-form>
                            </v-col>
                            <v-col sm="3">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span @click="handleClickToConfirmTime(time, i, index)" style="cursor: pointer; widht:20px; margin-right: 5px;" :style="time.userLoginHourID > 0 ? '' : 'opacity: 0.5;'" v-show="time.isEditable && time.inputValidations.startHour && time.isEditable && time.inputValidations.endHour " v-bind="attrs" v-on="on">
                                            <img src="/images/_SVGs/bo/check.svg"  onload="SVGInject(this)" width="15" height="15" fill="green"/>
                                        </span>
                                        <span style="cursor: no-drop; widht:20px; margin-right: 5px;" :style="time.userLoginHourID > 0 ? '' : 'opacity: 0.5;'" v-show="time.isEditable && !time.inputValidations.startHour || time.isEditable && !time.inputValidations.endHour" v-bind="attrs" v-on="on">
                                            <img src="/images/_SVGs/bo/check.svg"  onload="SVGInject(this)" width="15" height="15" fill="gray"/>
                                        </span>
                                    </template>
                                    <span>{{$t('backoffice.actions.record')}} </span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span @click="handleClickToCancel(i, time, index)" style="cursor: pointer; widht:20px;" v-show="time.isEditable" v-bind="attrs" v-on="on">
                                            <img src="/images/_SVGs/environmental/fechar.svg"  onload="SVGInject(this)" width="25" height="25" fill="red"/>
                                        </span>
                                    </template>
                                    <span>{{$t('backoffice.actions.cancel')}} </span>
                                </v-tooltip>
                            </v-col>
                        </v-col>
                        <v-col v-else cols="12" class="d-flex flex-row">
                            <v-col sm="2"><span>{{time.startHour}}</span></v-col>
                            <v-col sm="2"><span>{{time.endHour}}</span></v-col>
                            <v-col sm="4">
                                <span class="ml-4" v-show="time.isEditable == false">
                                  <v-tooltip bottom>
                                      <template v-slot:activator="{ on, attrs }">
                                          <span @click="handleClickToEdit(time, i, index)" style="cursor: pointer;" v-bind="attrs" v-on="on" v-show="!blockAddBtn">
                                              <img src="/images/_SVGs/bo/edit_pencil.svg" onload="SVGInject(this)" width="20" height="20"/>
                                          </span>
                                          <span style="cursor: no-drop;" v-bind="attrs" v-on="on" v-show="blockAddBtn">
                                              <img src="/images/_SVGs/bo/edit_pencil.svg" onload="SVGInject(this)" width="20" height="20"/>
                                          </span>
                                      </template>
                                      <span>{{$t('module-budget.main-budget.service-pack.edit-pack')}}</span>
                                  </v-tooltip>
                                </span>
                                <span class="ml-4" v-show="time.isEditable == false">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span @click="handleClickToRemove(time, i, index)" style="cursor: pointer;" class="mr-2 p-0" v-bind="attrs" v-on="on" v-show="!blockAddBtn">
                                                <img src="/images/_SVGs/bo/remove.svg" alt="remover" onload="SVGInject(this)" width="30" height="30" class="circle"/>
                                            </span>
                                            <span style="cursor: no-drop;" class="mr-2 p-0" v-bind="attrs" v-on="on" v-show="blockAddBtn">
                                                <img src="/images/_SVGs/bo/remove.svg" alt="remover" onload="SVGInject(this)" width="30" height="30" class="circle"/>
                                            </span>
                                        </template>
                                        <span>{{$t('module-budget.main-budget.service-pack.remove-pack')}}</span>
                                    </v-tooltip>
                                </span>
                            </v-col>
                        </v-col>
                    </v-row>
                    <v-col cols="12" class="d-flex p-0 mt-6">
                        <v-btn
                            fab
                            dark
                            x-small
                            :color="blockAddBtn ? '#eeeeee' : '#F59534'"
                            rounded
                            class="add-btn"
                            style="min-width: 30px !important"
                            :style="blockAddBtn ? 'cursor: no-drop' : ''"
                            @click="blockAddBtn ? '' : handleClickToAddNewTimeRange(day, i)"
                            :readonly="blockAddBtn"
                        >
                            <v-icon :style="'color: white'">
                                mdi-plus
                            </v-icon>
                        </v-btn>
                        <span :style="blockAddBtn ? 'cursor: no-drop' : ''" @click="blockAddBtn ? '' : handleClickToAddNewTimeRange(day, i)" class="ml-3 btn-span mt-1" style="cursor: pointer">{{$t('backoffice.user-management.form-user.user-access-config.add-new-hour')}}</span>
                    </v-col>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</div>
</template>

<script>

import { required } from '@src/utils/validations.js';

export default {
    props: {
        userWeekDays: Array
    },

    data() {
        return {
            weekDays: [
                {
                    name: this.$t('backoffice.general.monday'),
                    id: 1,
                    timeRanges: [
                        {
                            startHour: '10:00',
                            endHour: '14:00',
                            userLoginHourID: 1,
                            isEditable: false,
                            inputValidations: {
                                startHour: false,
                                endHour: false
                            }
                        }
                    ]
                },
                { name: this.$t('backoffice.general.tuesday'), id: 2, timeRanges: [] },
                { name: this.$t('backoffice.general.wednesday'), id: 3, timeRanges: [] },
                { name: this.$t('backoffice.general.thursday'), id: 4, timeRanges: [] },
                { name: this.$t('backoffice.general.friday'), id: 5, timeRanges: [] },
                { name: this.$t('backoffice.general.saturday'), id: 6, timeRanges: [] },
                { name: this.$t('backoffice.general.sunday'), id: 7, timeRanges: [] },
            ],
            blockAddBtn: false,
            defaultTimeRange: {
                startHour: '20:00',
                endHour: '23:59',
                userLoginHourID: 0,
                isEditable: true,
                inputValidations: {
                    startHour: false,
                    endHour: false
                },
                isNew: true
            },
            modal1: false,
            modal2: false,
            formRules: {
                defaultRules: [required],
            },
            temporaryEditable: {},
            showPanel: false,
        }
    },

    watch: {
        weekDays: {
            handler: function(newValue, oldValue) {
                if(!this.blockAddBtn) {
                    this.$emit('on-change-weekdays', newValue);
                }
                return newValue;
            },
            immediate: true,
            deep: true
        },
    },

    methods: {
        handleClickToAddNewTimeRange(weekDay, index) {
            const newTimeRange = _.cloneDeep(this.defaultTimeRange);
            this.weekDays[index].timeRanges.push(newTimeRange);
            this.blockAddBtn = true;
        },
        async handleClickToConfirmTime(time, indexWeek, indexTime) {
          let cloneList = _.cloneDeep(this.weekDays);
          let newTimeRange = _.cloneDeep(time);
          if(newTimeRange.isNew){
            delete newTimeRange.isNew;
          }
          const filterTimes = cloneList[indexWeek].timeRanges.filter(e => e.userLoginHourID != 0);
          //newTimeRange.userLoginHourID = filterTimes.length > 0 ? _.last(filterTimes).userLoginHourID+1 : -1;
          newTimeRange.userLoginHourID = -1;
          newTimeRange.isEditable = false;
          cloneList[indexWeek].timeRanges[indexTime] = newTimeRange;
          this.blockAddBtn = false;

          await this.$nextTick();

          this.weekDays = cloneList;
        },
        async handleClickToCancel(indexWeek, time, index) {
            let cloneList = _.cloneDeep(this.weekDays);
            if(time.isNew) {
              cloneList[indexWeek].timeRanges.splice(-1);
            } else {
              cloneList[indexWeek].timeRanges[index].isEditable = false;
              cloneList[indexWeek].timeRanges[index] = _.cloneDeep(this.temporaryEditable);
            }
            this.blockAddBtn = false;

            await this.$nextTick();

            this.weekDays = cloneList;
            this.temporaryEditable = {}
        },
        async handleClickToRemove(time, indexWeek, indexTime) {
            let cloneList = _.cloneDeep(this.weekDays);
            let newTimeRangeList = [];
            cloneList[indexWeek].timeRanges.forEach((el, index) => {
                if(index != indexTime) {
                    newTimeRangeList.push(el);
                }
            })
            cloneList[indexWeek].timeRanges = newTimeRangeList;

            await this.$nextTick();
            this.weekDays = cloneList;
        },
        async handleClickToEdit(time, indexWeek, indexTime) {
          let cloneList = _.cloneDeep(this.weekDays);
          this.temporaryEditable = _.cloneDeep(time);
          cloneList[indexWeek].timeRanges.forEach((el, index) => {
            if(index == indexTime) {
              Object.assign(el, { isEditable: true })
            }
          })
          await this.$nextTick();
          this.weekDays = cloneList;
          this.blockAddBtn = true;
        },
        handleClickPanelHeader(indexWeek) {
            if(this.blockAddBtn) {
                this.handleClickToCancel(indexWeek);
            }
        },
        saveStartHour(startHour) {
            if(this.$refs.startHour) {
                this.$refs.startHour[0].save(startHour);
            }
            this.modal1 = false;
        },
        saveEndHour(endHour) {
            if(this.$refs.endHour) {
                this.$refs.endHour[0].save(endHour);
            }
            this.modal2 = false;
        },
        startHourRulesForm(startHour, endHour, weekDay, index) {
          if(weekDay.timeRanges.length > 1) {
            const pickLastElement = weekDay.timeRanges[index-1];
            const pickAfterElement = weekDay.timeRanges[index+1];
            if(pickLastElement && pickAfterElement && startHour <= pickLastElement.endHour) {
              return this.$t('backoffice-form-user-hours-config-rule1')
            } else if (pickLastElement && pickAfterElement && startHour >= pickAfterElement.startHour) {
              return this.$t('backoffice-form-user-hours-config-rule2')
            } else if(pickLastElement && startHour < pickLastElement.endHour) {
              return this.$t('backoffice-form-user-hours-config-rule1')
            } else if (pickLastElement && startHour == pickLastElement.endHour) {
              return this.$t('backoffice-form-user-hours-config-rule3')
            } else if (!pickLastElement && pickAfterElement && startHour > pickAfterElement.startHour) {
              return this.$t('backoffice-form-user-hours-config-rule4')
            } else if(!pickLastElement && pickAfterElement && startHour == pickAfterElement.startHour) {
              return this.$t('backoffice-form-user-hours-config-rule5')
            } else if(startHour == endHour) {
              return this.$t('backoffice.user-management.form-user.user-access-config.rules-controll.equal-hour');
            } else if(startHour > endHour) {
              return this.$t('backoffice.user-management.form-user.user-access-config.rules-controll.higher-hour');
            } else {
              return !!startHour || this.$t('backoffice.modules-management.planning.form.rules.required-field');
            }
          }

          if(startHour > endHour) {
              return this.$t('backoffice.user-management.form-user.user-access-config.rules-controll.higher-hour');
          } else if (startHour == endHour) {
              return this.$t('backoffice.user-management.form-user.user-access-config.rules-controll.equal-hour');
          } else {
            return !!startHour || this.$t('backoffice.modules-management.planning.form.rules.required-field');
          }
        },
        endHourRulesForm(startHour, endHour, weekDay, index) {
          if(weekDay.timeRanges.length > 1) {
            const pickLastElement = weekDay.timeRanges[index-1];
            const pickAfterElement = weekDay.timeRanges[index+1];
            if(startHour == endHour) {
              return this.$t('backoffice.user-management.form-user.user-access-config.rules-controll.equal-hour');
            } else if (startHour > endHour) {
              return this.$t('backoffice.user-management.form-user.user-access-config.rules-controll.end-higher-hour');
            } else if(pickAfterElement && endHour >= pickAfterElement.startHour) {
              return this.$t('backoffice-form-user-hours-config-rule6')
            } else if(pickLastElement && endHour <= pickLastElement.endHour) {
              return this.$t('backoffice-form-user-hours-config-rule7')
            } else if(!pickAfterElement && startHour == endHour){
              return this.$t('backoffice.user-management.form-user.user-access-config.rules-controll.equal-hour');
            } else if(!pickAfterElement && startHour > endHour) {
              return this.$t('backoffice.user-management.form-user.user-access-config.rules-controll.end-higher-hour');
            } else {
              return !!startHour || this.$t('backoffice.modules-management.planning.form.rules.required-field');
            }
          }

          if(startHour > endHour) {
              return this.$t('backoffice.user-management.form-user.user-access-config.rules-controll.end-higher-hour');
          } else if (startHour == endHour) {
              return this.$t('backoffice.user-management.form-user.user-access-config.rules-controll.equal-hour');
          } else {
              return !!startHour || this.$t('backoffice.modules-management.planning.form.rules.required-field');
          }
        },
        tanslateDayName(dayName) {
            switch (dayName) {
                case 'Sunday':
                    return this.$t('backoffice.general.sunday');
                    break;
                case 'Monday':
                    return this.$t('backoffice.general.monday');
                    break;
                case 'Tuesday':
                    return this.$t('backoffice.general.tuesday');
                    break;
                case 'Wednesday':
                    return this.$t('backoffice.general.wednesday');
                    break;
                case 'Thursday':
                    return this.$t('backoffice.general.thursday');
                    break;
                case 'Friday':
                    return this.$t('backoffice.general.friday');
                    break;
                case 'Saturday':
                    return this.$t('backoffice.general.saturday');
                    break;
                default:
                    `${dayName}`;
            }
        },
        showPanelFn() {
          this.showPanel = !this.showPanel;
        }
    },

    mounted() {
        this.weekDays = this.userWeekDays;
    }
}
</script>

<style lang="scss" scoped>
@import "@sass/_variables.scss";
.div-spans-title {
    width: 100%;
        .div-bottom-line {
            border-bottom: 1px solid $grey-border-tab;
            width: 75%;
            border-bottom-width: 1px;
            margin-top: 9px;
            @media(max-width: 501px) {
                width: 100%;
            }
        }
    .span-laboral {
        margin-bottom: -15px;
        font-size: 18px;
        font-weight: bold;
        cursor: pointer;
    }
}

.v-expansion-panel-header--active {
    background-color: #f2f2f2 !important;
}

.rotated {
  transform: rotate(180deg);
  transition: transform 0.3s ease;
}

.rotatedback {
  transform: rotate(0deg);
  transition: transform 0.3s ease;
}
</style>
